import api from './api';
import {setToken} from './servicesGetCookie';

export const UpdateFBIGToken = async(TokenFB) =>{
    const AUTH_TOKEN = setToken();
    const resposta = await api.post(`UpdateFBIGToken?Token=${TokenFB}`,
    {'headers':{'Authorization':`Bearer ${AUTH_TOKEN}`}} ).then((response)=>{
        return response.data;
    }).catch((error)=>{
            return error;

    })

    return resposta;
}
